import api from '../utils/api';

export const userService = {
  // ดึงรายการผู้ใช้ทั้งหมด
  getAllUsers: async () => {
    try {
      const response = await api.get('/api/users');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // ดึงข้อมูลผู้ใช้ตาม ID
  getUserById: async (id) => {
    try {
      const response = await api.get(`/api/users/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // สร้างผู้ใช้ใหม่
  createUser: async (userData) => {
    try {
      const response = await api.post('/api/users', userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // แก้ไขข้อมูลผู้ใช้
  updateUser: async (id, userData) => {
    try {
      const response = await api.put(`/api/users/${id}`, userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // ลบผู้ใช้
  deleteUser: async (id) => {
    try {
      const response = await api.delete(`/api/users/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // เปลี่ยนรหัสผ่าน
  changePassword: async (id, passwordData) => {
    try {
      const response = await api.put(`/api/users/${id}/password`, passwordData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // ดึงข้อมูล profile ของผู้ใช้ปัจจุบัน
  getCurrentUser: async () => {
    try {
      const response = await api.get('/api/users/profile');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // อัพเดท profile ของผู้ใช้ปัจจุบัน
  updateProfile: async (profileData) => {
    try {
      const response = await api.put('/api/users/profile', profileData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};